import ROUTES from 'CONSTANTS/routes';
import LandingPage from '../features/LandingPage';

const interpreterRoutes = [{ path: `${ROUTES.INTERPRETER}/:meetingId`, element: <LandingPage /> }];

export default interpreterRoutes;

// this file is obsolete but not removed till v1.6.0 is released
